export const initialDecoratorState = {
    selectedDecorator: null,
    description: '',
    supplierId:'',
    addressId:'',
    CurrencyCode: '',
    isEliteDecorator:false,
    decorations: [],
};

export const decoratiosState = {
    chargeName: '',
    chargeType: '',
    type: 'Table',
    rows: 1,
    description: '',
    breakdown: 1,
    charges: [],
    tableValues: [],
    columns: [
        { accessorKey: 'Unit', header: 'Unit' },
    ],
    rowsData: [
        { Unit: '' },
    ],
    increment: '1',
    units: '',
    requiresProof: true,
    productionDepartmentId: ''
}



export const formatDecorations = (decorations=[]) => {
    return (Array.isArray(decorations) ? decorations : []).map((decoration) => {
        if (!decoration || typeof decoration !== 'object') return null;
        const tableData = decoration.priceTableData || {};
        const rawHeaders = Array.isArray(tableData.headers) ? tableData.headers : [];
        // List/per-item charges may not have a pricing table, but must still be visible.
        const headers = rawHeaders.length
            ? rawHeaders
            : (decoration.Type === 'List' || decoration.Type === 'Per Item' ? ['Unit'] : []);
        const rows = Array.isArray(tableData.rows) ? tableData.rows : [];
        if (!headers.length) return null;

        const staticHeader = headers[0];
        const dynamicHeaders = headers.slice(1);
        // Create table columns
        const tableHeader = dynamicHeaders.map((header) => {
            const label = String(header ?? '');
            // Only numeric "start-end" headers are range inputs. Preserve legacy
            // labels (e.g. "1", "Setup", "1 - 12") so a save cannot rename
            // their pricing keys or cause a null[0] crash during loading.
            const rangeMatch = /^(\d+)-(\d+)$/.exec(label);
            return {
                accessorKey: label,
                header: rangeMatch
                    ? { start: Number(rangeMatch[1]), end: Number(rangeMatch[2]) }
                    : label,
            };
        });
        const staticHeaders = [
            { accessorKey: 'Unit', header: staticHeader },
        ];

        const pricingData = rows.map((row) => {
            const safeRow = row && typeof row === 'object' ? row : {};
            const unit = safeRow[staticHeader];
            const prices = {};

            dynamicHeaders.forEach((header) => {
                prices[String(header ?? '')] = safeRow[header];
            });

            return { Unit: unit, ...prices };
        });
        return {
            id: decoration.id,
            archived: Boolean(decoration.archived),
            archivedAt: decoration.archivedAt || null,
            requiresProof: decoration.requiresProof !== false,
            productionDepartmentId: decoration.productionDepartmentId ?? '',
            chargeName: decoration.ChargeName || '',
            chargeType: decoration.ChargeType === 'Run' ? "Run Charge" : 'Fixed Charge',
            type: decoration.Type || '',
            rows: decoration.Rows || 0,
            breakdown: decoration.Breakdown || 0,
            units: decoration.units || '',
            increment: decoration.increment || 1,
            description: decoration.Description || '',
            columns: [...(staticHeaders || []), ...(tableHeader || [])],
            rowsData: pricingData,
            staticHeaders: ['Unit'],
            staticRows: [
                {
                    header: 'Unit',
                    values: pricingData.map(row => row.Unit),
                }
            ],
            charges: Array.isArray(decoration.ChargesList)
                ? decoration.ChargesList.filter(Boolean).map((charge) => ({ name: charge.ChargeName, price: charge.Price }))
                : []
        };
    }).filter(Boolean);
};


export const createDecoratorPayload = (formData, companyDefaultCurrencyCode = 'CAD') => {
    return {
        // title: formData.selectedDecorator,
        Description: formData.description,
        CurrencyCode: formData.CurrencyCode || companyDefaultCurrencyCode || 'CAD',
        Decorations: formData.decorations.map((decoration) => {
            const headers = decoration.columns.map((col, index) => {
                if (index === 0) return col.header;
                if (decoration.chargeType !== 'Run Charge') return col.header
                if (col.header?.start !== undefined && col.header?.end !== undefined) {
                    return `${col.header.start}-${col.header.end}`;
                }
                // Non-range legacy headers are valid pricing keys; do not
                // erase their values when an unrelated charge field is saved.
                return typeof col.header === 'string' || typeof col.header === 'number'
                    ? String(col.header)
                    : (col.accessorKey || '');
            });

            const rows = decoration.rowsData.map((row) => {
                const newRow = {...row};
                headers.forEach((header, index) => {
                    if (index === 0) {
                        newRow[header] = row['Unit'] ?? '';
                    } else {
                        // A range header can be renamed while the row still uses its
                        // original accessorKey (e.g. 12-23 -> 1-23). Carry the value
                        // forward instead of silently serializing an empty price.
                        const originalKey = decoration.columns[index]?.accessorKey;
                        newRow[header] = row[header] ?? row[originalKey] ?? '';
                        if (originalKey && originalKey !== header) {
                            delete newRow[originalKey];
                        }
                    }
                });
                return newRow;
            });
            const breakdown=headers.filter(header => header !== 'Cost').length-1
            return {
                id: decoration.id,
                requiresProof: decoration.requiresProof !== false,
                productionDepartmentId: decoration.productionDepartmentId || null,
                ChargeName: decoration.chargeName,
                ChargeType: decoration.chargeType
                    ? decoration.chargeType === 'Run Charge'
                        ? 'Run'
                        : 'Fixed'
                    : '',
                CalculationType: decoration.type,
                Rows: decoration.rows,
                BreakDown: decoration.chargeType === 'Run Charge' && decoration.type === "Table" ? breakdown : 1,
                Description: decoration.description,
                Increment: decoration.increment || '',
                Units: decoration.units || '',
                columns: headers,
                RangeTable: {
                    headers,
                    rows,
                },
                ChargePrices: (decoration.charges || []).map(charge => ({
                    ChargeName: charge.name || '',
                    Price: charge.price || ''
                }))
            };
        }),
        supplierId:formData.supplierId,
        addressId:formData.addressId
    };
};
